import { useEffect, useState } from 'react';

import { getRiderServices } from '../../../api/services/RiderServices';

export type LiveService = {
  code: string;
  name: string;
  detail?: string;
  shortDetail: string | null;
  available: boolean;
};

type State = { status: 'loading' } | { status: 'ready'; services: LiveService[] } | { status: 'error'; error: unknown };

export const useLiveServices = (): State => {
  const [state, setState] = useState<State>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;

    getRiderServices()
      .then((res) => {
        if (cancelled) {
          return;
        }
        setState({ status: 'ready', services: res.data.services });
      })
      .catch((error) => {
        if (cancelled) {
          return;
        }
        setState({ status: 'error', error });
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
};
